import AttendanceModal from './AttendanceModal';

export default AttendanceModal;
